// One library row of the Learn panel. LibrariesInLearn hands each row its item
// as state (`childrenAs: 'state'`); the row ships no data of its own. It used
// to default to a demo row — a real person's project path, a resource count, a
// poster — and that row showed on ANY element keyed `LibraryItemInLearn`, a
// generated app's included (R2-M1 sweep). The keys are declared empty so a
// bare row never reads the root state's `title`, and a row without a title
// stays hidden.
export const LibraryItemInLearn = {
  extends: ['Link', 'Flex'],
  state: {
    title: '',
    amount: null,
    poster: '',
    projectPath: ''
  },
  hide: (el, s) => !s.title,
  align: 'stretch',
  padding: '0',
  gap: 'A',
  round: '0',
  overflow: 'visible',
  cursor: 'pointer',
  opacity: '0.8',
  transition: 'A defaultBezier all',
  ':hover': {
    opacity: '1',
    '& .playButton': {
      opacity: '1'
    }
  },
  href: 'https://symbols.app/{{ projectPath }}',
  target: '_blank',
  Box: {
    position: 'relative',
    width: 'E3',
    Img: {
      display: 'block',
      round: 'radiusControl',
      position: 'relative',
      width: '100%',
      src: '{{ poster }}'
    }
  },
  Flex: {
    flow: 'y',
    gap: 'W2',
    Strong: {
      text: '{{ title }}'
    },
    Span: {
      whiteSpace: 'nowrap',
      fontWeight: '200',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      text: '{{ projectPath }}'
    },
    Span_2: {
      if: (el, s) => !!s.amount,
      margin: 'auto - -',
      fontWeight: '100',
      fontSize: 'Z2',
      text: (el, s) =>
        el.call('polyglot', 'learn.libraries.resources').replace('{amount}', s.amount),
      color: 'paragraph'
    }
  }
}
